var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
var LeilaoCountdown = /** @class */ (function (_super) {
    __extends(LeilaoCountdown, _super);
    function LeilaoCountdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.remainingSeconds = 0;
        _this.timerId = null;
        return _this;
    }
    Object.defineProperty(LeilaoCountdown.prototype, "formattedTime", {
        get: function () {
            if (this.remainingSeconds <= 0) {
                return "Encerrado";
            }
            var days = Math.floor(this.remainingSeconds / 86400);
            var hours = Math.floor((this.remainingSeconds % 86400) / 3600);
            var minutes = Math.floor((this.remainingSeconds % 3600) / 60);
            var seconds = this.remainingSeconds % 60;
            var parts = [];
            if (days > 0) {
                parts.push(String(days).padStart(2, "0") + " " + (days === 1 ? "dia" : "dias"));
            }
            parts.push(String(hours).padStart(2, "0") + " " + (hours === 1 ? "hora" : "horas"));
            parts.push(String(minutes).padStart(2, "0") + " " + (minutes === 1 ? "minuto" : "minutos"));
            var secondsLabel = seconds === 1 ? "segundo" : "segundos";
            if (parts.length === 0) {
                return String(seconds).padStart(2, "0") + " " + secondsLabel;
            }
            var lastPart = String(seconds).padStart(2, "0") + " " + secondsLabel;
            return parts.join(", ") + " e " + lastPart;
        },
        enumerable: false,
        configurable: true
    });
    LeilaoCountdown.prototype.updateRemaining = function () {
        var endTimestamp = new Date(this.endAt).getTime();
        if (Number.isNaN(endTimestamp)) {
            this.remainingSeconds = 0;
            return;
        }
        this.remainingSeconds = Math.max(0, Math.floor((endTimestamp - Date.now()) / 1000));
    };
    LeilaoCountdown.prototype.mounted = function () {
        var _this = this;
        this.updateRemaining();
        this.timerId = window.setInterval(function () {
            _this.updateRemaining();
        }, 1000);
    };
    LeilaoCountdown.prototype.beforeDestroy = function () {
        if (this.timerId !== null) {
            window.clearInterval(this.timerId);
        }
    };
    __decorate([
        Prop({ required: true })
    ], LeilaoCountdown.prototype, "endAt", void 0);
    LeilaoCountdown = __decorate([
        Component({
            components: {}
        })
    ], LeilaoCountdown);
    return LeilaoCountdown;
}(Vue));
export default LeilaoCountdown;
